// extracted by mini-css-extract-plugin
export default {"target":"target___dtVO1","flash-bg":"flash-bg___L91kr"};